import { useEffect, useRef, useState } from 'react';

export function useScrollButtons(itemsCount: number) {
  const navBarWrapperRef = useRef<HTMLDivElement>(null);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(false);

  const checkScroll = () => {
    const el = navBarWrapperRef.current;
    if (!el) return;
    setShowLeft(el.scrollLeft > 0);
    setShowRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
  };

  useEffect(() => {
    checkScroll();
    const el = navBarWrapperRef.current;
    if (!el) return;
    el.addEventListener('scroll', checkScroll);
    window.addEventListener('resize', checkScroll);
    return () => {
      el.removeEventListener('scroll', checkScroll);
      window.removeEventListener('resize', checkScroll);
    };
  }, [itemsCount]);

  const scrollNav = (dir: 'left' | 'right') => {
    const el = navBarWrapperRef.current;
    if (!el) return;
    el.scrollBy({
      left: dir === 'left' ? -200 : 200,
      behavior: 'smooth'
    });
  };

  return { navBarWrapperRef, showLeft, showRight, scrollNav };
}
